import React from "react";
import { Spinner } from "reactstrap";

const Spinners = ({ exibir }: { exibir: boolean }) => {
  return (
    <React.Fragment>
      {exibir ? (
        <div
          className="position-absolute top-0 start-0"
          style={{
            zIndex: 9999999,
            backgroundColor: "rgba(84, 88, 155, 0.61)",
            width: "100%",
            height: "100%",
          }}
        >
          <Spinner
            className="position-absolute top-50 start-50"
            animation="border"
            color="primary"
          />
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Spinners;
